/* eslint no-unused-vars: ["error", { "varsIgnorePattern": "picturefill" }] */
import picturefill from 'picturefill';
export default () => {

  document.createElement('picture');

};
